import { render, staticRenderFns } from "./TableGame.vue?vue&type=template&id=5784cc9b&scoped=true&"
import script from "./TableGame.vue?vue&type=script&lang=js&"
export * from "./TableGame.vue?vue&type=script&lang=js&"
import style0 from "./TableGame.vue?vue&type=style&index=0&id=5784cc9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784cc9b",
  null
  
)

export default component.exports